<template>
  <div class="upload-file-box">
    <el-upload class="upload-file" action="" :multiple="multiple" :accept="accept" :limit="limit" :auto-upload="false"
      :show-file-list="false" :on-exceed="handleExceed" :on-change="handleUploadChange" :file-list="uploadFileList"
      :disabled="disabled">
      <slot>
        <div class="upload-file-content" :class="!disabled ? 'icon_pc-upload_enable' : 'icon_pc-upload_disabled'">
          <div class="upload-btn" />
          <span>上传文件</span>
        </div>
      </slot>
    </el-upload>
    <file-list-box :imgList="imgList" :file-list="fileList" :upload-file-list="uploadFileList"
      @deleteUploadFileList="deleteUploadFileList" />
  </div>
</template>

<script>
import Compressor from "compressorjs";
import aliOSSUpload, {
  getFileSuffixType,
  getSuffixTypeOptions,
  getAcceptOptions,
  getFileName
} from "./ali-oss.js";
import FileListBox from "./FileListBox.vue";

export default {
  name: "TqUploadFile",
  components: { FileListBox },
  props: {
    modelValue: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: undefined
    },
    fileSize: {
      type: Number,
      default: 100 // 单位MB
    },
    fileTotalSize: {
      type: Number,
      default: 100 // 单位MB
    },
    compressorImage: {
      type: Boolean,
      default: false // 单位MB
    },
    compressorQuality: {
      type: Number,
      default: 0.8 // 单位MB
    },
    suffixType: {
      type: [String, Array],
      default: "" // microsoft-pdf-txt image microsoft
    },
    apiParams: {
      type: Object,
      default: () => {
        return {
          // url: "/file/getFileToken",
          // data: {},
          // mappingName: "chat",
          // method: "get",
          // appSource: ""
          // setCallbackVarParams: {'x:fileACL': 'private'}
        };
      },
      required: true
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      uploadFileList: [],
      imgList: [],
      fileList: [],
      inputoffset: 0,
      file: null
    };
  },
  computed: {
    accept() {
      return getAcceptOptions(this.suffixType);
    }
  },
  watch: {
    modelValue: {
      handler(newValue, oldValue) {
        console.log("🚀 ~ handler ~ newValue:", newValue);
        // 初始化上传文件
        if (oldValue && oldValue.length < 1 && newValue.length > 0) {
          this.refreshUploadFile(newValue);
        }
      },
      deep: true
    },
    uploadFileList: {
      handler(newValue) {
        this.$emit("update:modelValue", newValue);
      },
      deep: true
    }
  },
  created() {
    this.refreshUploadFile(this.modelValue); // 初始化上传文件
  },
  methods: {
    refreshUploadFile(fileList) {
      const uploadFileList = [];
      let initFileList = true; // 是否是初始化传入的文件
      fileList.forEach((file, index) => {
        // 外部传入的文件 不带uid 要初始化数据
        if (file.uid) {
          initFileList = false;
          return file;
        }
        let url = file.url;
        let fileData = {};
        let suffix = getFileSuffixType(url);
        let fileName = getFileName(url);
        fileData.uid = new Date().getTime() + "_" + index;
        fileData.fileType = suffix;
        fileData.fileNameAlias = fileName;
        fileData.name = file.name || url;
        fileData.url = url;
        fileData.previewUrl = url;
        fileData.status = "success";
        fileData.message = "上传成功";
        if (["jpg", "jpeg", "png", "bmp", "gif"].includes(suffix)) {
          this.imgList.push(fileData);
        } else {
          this.fileList.push(fileData);
        }
        uploadFileList.push(fileData);
      });
      if (initFileList) {
        this.uploadFileList = uploadFileList;
      }
    },
    // 清空已选文件
    clearFileList() {
      this.uploadFileList = [];
      this.imgList = [];
      this.fileList = [];
    },
    // 返回已选文件
    getFileList() {
      const list = [];
      const uploadFileList = [...this.fileList, ...this.imgList];
      uploadFileList.forEach(item => {
        list.push({
          fileId: item.fileId,
          fileName: item.fileName,
          fileSize: item.size,
          fileType: item.fileType
        });
      });
      return list;
    },
    // 文件超出限制
    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length +
        this.uploadFileList.length} 个文件`
      );
    },
    // oss上传文件
    verifyAliOSSUpload(file) {
      console.log("🚀 ~ verifyAliOSSUpload ~ file:", file);
      const uploadParams = {
        file: file.raw,
        apiParams: this.apiParams
      };
      console.log(
        "🚀 ~ verifyAliOSSUpload ~ uploadParams:",
        uploadParams
      );
      aliOSSUpload(uploadParams)
        .then(result => {
          console.log(
            "🚀 ~ verifyAliOSSUpload ~ result:",
            result,
            file
          );
          file.previewUrl = result.previewUrl;
          file.status = "success";
          file.message = "上传成功";
        })
        .catch(() => {
          file.status = "failed";
          file.message = "上传失败";
        });
    },
    // 选择文件
    async handleUploadChange(file, fileList) {
      this.uploadFileList = fileList;
      this.file = file;
      file = this.file; // 设置响应式
      // 校验空文件
      if (file.size === 0) {
        this.deleteUploadFileList(file);
        this.$message.warning("上传附件内容不能为空");
        return false;
      }
      // 校验文件类型
      let suffix = getFileSuffixType(file.name);
      const suffixOptions = getSuffixTypeOptions(this.suffixType);
      if (suffixOptions.length > 0) {
        if (!suffixOptions.includes(suffix)) {
          this.$message.warning(`不支持${suffix}格式的附件上传`);
          this.deleteUploadFileList(file);
          return false;
        }
      }
      file.fileType = suffix;
      file.fileNameAlias = getFileName(file.name);
      file.status = "uploading";
      file.message = "上传中...";
      if (file.raw.type.includes("image")) {
        if (this.compressorImage) {
          file.raw = await this.compressorAndWatermark(file.raw);
          file.size = file.raw.size;
        }
        // 校验单个文件大小
        if (!this.verifyOneFileSize(file)) {
          return;
        }
        // 校验文件大小
        if (!this.verifyFileSize(file)) {
          return;
        }
        file.url = URL.createObjectURL(file.raw);
        this.imgList.push(file);
      } else {
        file.Bytes = this.formatBytes(file.size);
        // 校验单个文件大小
        if (!this.verifyOneFileSize(file)) {
          return;
        }
        // 校验文件大小
        if (!this.verifyFileSize(file)) {
          return;
        }
        this.fileList.push(file);
      }
      this.verifyAliOSSUpload(file);
    },
    // 删除文件
    deleteUploadFileList(file) {
      const index = this.uploadFileList.findIndex(item => {
        return item.uid == file.uid;
      });
      index > -1 && this.uploadFileList.splice(index, 1);
    },
    // 格式化字节大小显示
    formatBytes(bytes, decimals = 2) {
      if (!Number(bytes)) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]
        }`;
    },
    // // 压缩
    compressorAndWatermark(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: this.compressorQuality,
          convertSize: 100000, // 超过100KB 超过该convertSize值的文件将被转换为 JPEG。
          success: async result => {
            let file = new window.File([result], result.name, {
              type: result.type
            });
            resolve(file);
          },
          error(err) {
            // this.$message.warning(`压缩失败,请重试！`);
            reject(err);
          }
        });
      });
    },
    // 校验文件大小
    verifyFileSize(file) {
      if (!this.fileTotalSize) {
        return true;
      }
      let totalSize = 0;
      if (this.uploadFileList.length > 0) {
        this.uploadFileList.forEach(file => {
          totalSize += file.size;
        });
        const maxSizeInBytes = this.fileTotalSize * 1024 * 1024; // MB in bytes
        if (totalSize > maxSizeInBytes) {
          this.deleteUploadFileList(file);
          this.$message.warning(
            `单次最多上传${this.limit}个文件/总文件大小${this.fileTotalSize}M`
          );
          return false;
        }
        return true;
      }
      return true;
    },
    // 校验单个文件大小
    verifyOneFileSize(file) {
      if (!this.fileSize) {
        return true;
      }
      const maxSizeInBytes = this.fileSize * 1024 * 1024; // MB in bytes
      if (file.size > maxSizeInBytes) {
        this.deleteUploadFileList(file);
        this.$message.warning(`单个文件最大限制${this.fileSize}M`);
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang='scss' scoped>
.upload-file-content {
  display: flex;
  align-items: center;

  &.icon_pc-upload_enable {
    .upload-btn {
      background-image: url("../images/icon_pc-upload_enable.svg");
    }
  }

  &.icon_pc-upload_disabled {
    color: #ccc;

    .upload-btn {
      background-image: url("../images/icon_pc-upload_disabled.svg");
    }
  }

  .upload-btn {
    width: 40px;
    height: 40px;
  }
}
</style>
